import { DayOfWeek } from './day-of-week.enum';

/**
 * Canonical Monday-to-Sunday ordering of the week.
 * Single source of truth for any UI that renders weekday columns/toggles.
 */
export const ORDERED_DAYS_OF_WEEK: DayOfWeek[] = [
  DayOfWeek.Monday,
  DayOfWeek.Tuesday,
  DayOfWeek.Wednesday,
  DayOfWeek.Thursday,
  DayOfWeek.Friday,
  DayOfWeek.Saturday,
  DayOfWeek.Sunday,
];
